import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialButton from "../../../components/MaterialButton";
import colors from "../../../assest/theme/base/colors";
import { Box, Dialog } from "@mui/material";
import DynamicTableProps from "../../Utils/DynamicTableProps";
import ConfirmDialog from "../../Utils/ConfirmDialog";
import AddIndustryMaster from "./AddIndustryMaster";
import MessagePopup from "../../Utils/MessagePopup";
import { deleteItem, fetchAll, fetchById, FetchDataGet } from "../../../BaseUrl";
import { DELETEINDUSTRYBYID, GETINDUSTRY, GETINDUSTRYBYID } from "./Mutation";
import AccessComponent from "../../Utils/AccessComponent";
import LoadingSpinner from "../../loader/loadercomp";

function IndustryMaster() {
  const [industryData, setIndustryData] = useState([]);
  const [oneIndustryData, setOneIndustryData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isView, setIsView] = useState(false);
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState({
    title: "",
    content: "",
    onConfirm: () => {},
  });
  const [popup, setPopup] = useState({
    open: false,
    message: "",
    severity: "success", // 'success' or 'error'
  });
const [Loader, setLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [searchdata, setsearchdata] = useState("");
  const [sortedvalue, setsortedvalue] = useState("");
  const [serverPage, setServerPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [prevSearch, setPrevSearch] = useState("");

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      let currentPage = serverPage;
      if (searchdata !== prevSearch) {
        setServerPage(1);
        currentPage = 1;
        setPrevSearch(searchdata);
      }
      getIndustryData(currentPage, searchdata);
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchdata, serverPage]);

   
  

  const columns = [
    { label: "Industry Type", field: "industryType" },
    { label: "Hiring Type", field: "hiringType" },
    { label: "Actions", field: "actions" },
  ];

  const validIndustryData = Array.isArray(industryData) ? industryData : [];

  const sortedData = [...validIndustryData].sort((a, b) => {
    const sortOption = sortedvalue?.value || "descending"; // default to descending
    switch (sortOption) {
      case "ascending":
        return new Date(a.createdAt) - new Date(b.createdAt);
      case "descending":
        return new Date(b.createdAt) - new Date(a.createdAt);
      default:
        return validIndustryData; // default to descending
    }
  });

  const formClose = () => {
    setOpen(false);
    setOneIndustryData([]);
    handleCloseDialog();
  };

  const addRole = () => {
    setIsView(false);
    setOpen(true);
  };

  const onView = (id) => {
    setIsView(true);
    getIndustryById(id);
    setOpen(true);
  };

  const onEdit = (id) => {
    setIsView(false);
    getIndustryById(id);
    setOpen(true);
  };

  //delete popup function
  const onDelete = (id) => {
    handleOpenDialog();
    setDialogData({
      title: "Are you sure you want to delete Industry ?",
      content: `If you delete the field you can’t recover it`,
      onConfirm: () => deleteRole(id),
    });
  };

  //open and close dialog for confirmation
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  //delete api call
  const deleteRole = async (id) => {
    const variables = {
      id: id,
    };
    try {
      const response = await deleteItem(DELETEINDUSTRYBYID, {
        input: variables,
      });
      if (response?.deleteIndustry?.success === true) {
        setIndustryData(response?.deleteIndustry?.data);
        setPopup({
          open: true,
          message: response?.deleteIndustry?.message,
          severity: "success",
        });
      } else {
        setPopup({
          open: true,
          message: response?.deleteIndustry?.message,
          severity: "error",
        });
      }
    } catch (error) {
      setPopup({
        open: true,
        message: error,
        severity: "success",
      });
      console.error(error);
    } finally {
      getIndustryData(serverPage, searchdata);
      handleCloseDialog();
    }
  };

  //get api call
  const getIndustryData = async (page = serverPage, search = searchdata) => {
     setLoader(true)
    setIsLoading(true);
    try {
      const variables = {
        search: search,
        page: page,
        pageSize: 10,
      };
      const response = await FetchDataGet(GETINDUSTRY, variables);
      if (response?.getAllIndustries?.success === true) {
        setTotalCount(response?.getAllIndustries?.totalCount || 0);
        setIndustryData(response?.getAllIndustries?.data);
      } else {
        setIndustryData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false)
    }
    setIsLoading(false);
  };

  //get by id api call
  const getIndustryById = async (id) => {
    const variables = {
      industryId: id,
    };
    try {
      const response = await fetchById(GETINDUSTRYBYID, variables);
      if (response?.getIndustryById?.success === true) {
        setOneIndustryData(response?.getIndustryById?.data);
      } else {
        setOneIndustryData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  return (
    <DashboardLayout searchdata={searchdata} setsearchdata={setsearchdata}>
      <ConfirmDialog
        open={dialogOpen}
        title={dialogData.title}
        content={dialogData.content}
        onClose={handleCloseDialog}
        onConfirm={dialogData.onConfirm}
      />
      {Loader && <LoadingSpinner />}
      <MessagePopup
        message={popup.message}
        severity={popup.severity}
        open={popup.open}
        setPopup={setPopup}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", width: "98%" }}>
        <AccessComponent name="Industry Master" action="Create">
          <MaterialButton
            variant="contained"
            onClick={() => {
              addRole();
            }}
            sx={{
              background: colors.buttonColor,
              color: "#fff",
              textTransform: "capitalize",
            }}
          >
            + Add Industry
          </MaterialButton>
        </AccessComponent>
        <Dialog open={open}>
          <AddIndustryMaster
            formClose={formClose}
            getIndustryData={getIndustryData}
            oneIndustryData={oneIndustryData}
            setPopup={setPopup}
            isView={isView}
            handleOpenDialog={handleOpenDialog}
            setDialogData={setDialogData}
          />
        </Dialog>
      </Box>
      <DynamicTableProps
        columns={columns}
        rows={sortedData}
        onView={onView}
        onEdit={onEdit}
        onDelete={onDelete}
        name="Industry Master"
        isLoading={isLoading}
        serverPage={serverPage}
        totalCount={totalCount}
        onPageChange={(event, newPage) => setServerPage(newPage)}
      />
    </DashboardLayout>
  );
}

export default IndustryMaster;
